import {
  useMarkNotificationRead as useMarkNotificationReadApi,
  getListNotificationsQueryKey,
} from '@/shared/api/generated/notifications';
import { queryClient } from '@/shared/api';

export const useMarkNotificationRead = () => {
  return useMarkNotificationReadApi({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getListNotificationsQueryKey() });
      },
    },
  });
};
